// src/components/admin/AdminDashboard.js
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { AuthContext } from '../../contexts/AuthContext';
import { useTheme, useMediaQuery } from '@mui/material';

const drawerWidth = 300;

const AdminDashboard = () => {
    const { logout } = useContext(AuthContext);
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    const contentStyles = {
        marginLeft: isLargeScreen ? `${drawerWidth}px` : 0,
        padding: '16px',
    };

    return (
        <div className="dashboard-container">
            <AdminSidebar onLogout={logout} />
            <div className="dashboard-content" style={contentStyles}>
                <Outlet />
            </div>
        </div>
    );
};

export default AdminDashboard;
